//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    // 双向绑定选中发票列表
    value: {
      type: Array,
      default: () => []
    },
    // 列表数据
    invoiceInfo: {
      type: Array
    },
    // 0：待开发票  1：已开发票
    listType: {
      type: String,
      default: ""
    }
  },
  // watch: {
  //   value: {
  //     handler(val) {
  //       console.log(val, 'value');
  //     },
  //     deep: true
  //   }
  // },
  data() {
    return {
      result: []
    };
  },
  methods: {
    // 选择发票触发
    changeCheckBox(e) {
      let arr = [];
      e.map(m => {
        this.invoiceInfo.map((v, i) => {
          if (m === i) {
            arr.push(v);
          }
        });
      });
      this.$emit("input", arr);
    },
    // 查看详情
    onDetail(data) {
      this.$router.push({
        path: "/InvoiceDetail",
        query: {
          invoiceData: JSON.stringify(data)
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/invoice-info/invoice-info.vue